<div class="pt-3" *ngIf="!accountService.getMyAccount().can_manage_events">
  <h2>You do not have permission to set up events.</h2>
</div>

<div *ngIf="accountService.getMyAccount().can_manage_events">
  <nav *ngIf="displayNav"
       class="navbar navbar-expand navbar-light bg-light capitan-sub-nav bg-sub-nav-2 pl-md-5">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="./event-types" routerLinkActive="active" class="nav-link" href="#">Event Types</a>
      </li>
      <li class="nav-item">
        <a routerLink="./discounts" routerLinkActive="active" class="nav-link" href="#">Discounts</a>
      </li>
      <li class="nav-item">
        <a routerLink="./categories" routerLinkActive="active" class="nav-link" href="#">Categories</a>
      </li>
      <li class="nav-item">
        <a routerLink="./voucher-packs" routerLinkActive="active" class="nav-link" href="#">Voucher Packs</a>
      </li>
    </ul>
  </nav>

  <router-outlet></router-outlet>
</div>
